import React from "react";

interface FormLabelProps {
  label: string | null;
  required?: boolean;
}

const FormLabel: React.FC<FormLabelProps> = ({ label, required }) => (
  <span className="customize-form-label">
    {label}
    {required && <span style={{ color: "red" }}>*</span>}
  </span>
);

export default FormLabel;
